/**
 * Boundary-safe route matcher — prevents `/login-page` from matching `/login`.
 * A pathname matches when it equals the route exactly or continues with `/`.
 */
export function matchesRoute(pathname: string, route: string): boolean {
  return pathname === route || pathname.startsWith(`${route}/`);
}

export function matchesAnyRoute(pathname: string, routes: string[]): boolean {
  return routes.some((route) => matchesRoute(pathname, route));
}
